"use client";

import { cn } from "@/lib/utils";
import { motion } from "framer-motion";
import {
  UserCog,
  BookOpen,
  CopyCheck,
  Coins,
  
} from "lucide-react";
import Link from "next/link";
import React, { useEffect } from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const menuItems = [
  { label: "Token", href: "/token", icon: Coins },
  { label: "Protocol", href: "/protocol", icon: UserCog },
  { label: "Community", href: "/community", icon: CopyCheck },
  {
    label: "Docs",
    href: "https://docs.blokcapital.io/",
    icon: BookOpen,
    external: true,
  },
  
];

const MobileMenu = ({ isOpen, setIsOpen }: Props) => {
  const variants = {
    open: { opacity: 1, y: 20 },
    closed: { opacity: 0, y: 0 },
  };

  // Close mobile menu when screen size changes to large size
  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 1024px)");
    const handleResize = () => {
      if (mediaQuery.matches) {
        setIsOpen(false);
      }
    };
    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, [setIsOpen]);

  return (
    <div
      className={cn(
        "absolute top-12 inset-x-0 size-full p-4 z-20 bg-inherit flex flex-1",
        isOpen ? "flex" : "hidden"
      )}
    >
      <motion.div
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        variants={variants}
        transition={{
          type: "spring",
          bounce: 0.15,
          duration: 0.5,
        }}
        className="size-full flex flex-col justify-start"
      >
        <ul className="flex flex-col items-start flex-1 w-full space-y-3">
          {menuItems.map(({ label, href, icon: Icon, external }) => (
            <li
              key={label}
              onClick={() => setIsOpen(false)}
              className="w-full px-4 py-2 text-lg hover:text-muted-foreground font-normal transition transform rounded-md cursor-pointer text-foreground text-start active:scale-95 hover:bg-muted/20 active:opacity-80"
            >
              <Link
                href={href}
                {...(external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
                className="flex items-center w-full text-start"
              >
                <Icon className="w-4 h-4 mr-2" />
                {label}
              </Link>
            </li>
          ))}
        </ul>
      </motion.div>
    </div>
  );
};

export default MobileMenu;
